import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OutbreakMapPage from './pages/OutbreakMapPage';
import FaqPage from './pages/FaqPage';
import AboutPage from './pages/AboutPage';

function App() {
  useEffect(() => {
    document.title = 'OutbreakMap - Live Global Disease Outbreak Tracker';
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OutbreakMapPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
